/**
 * Logistics reducer slice. Handles:
 *   logistics.MilestoneRecorded   — cold-chain milestones (Loading / Departure / Arrival)
 *   logistics.SingleWindowCleared — customs/dubaiTrade single-window clearance
 *   logistics.MoccaeCleared       — MOCCAE clearance
 *
 * Pure function: `(state, ev) => state`.
 */

import type { CdmEvent, EventLogState } from "@/lib/sse/useSSE";

export function logisticsReducer(state: EventLogState, ev: CdmEvent): EventLogState {
  switch (ev.eventType) {
    case "logistics.MilestoneRecorded": {
      return {
        ...state,
        logisticsMilestones: [
          ...state.logisticsMilestones,
          {
            milestone: ev.payload.milestone as string,
            vesselImo: ev.payload.vesselImo as string | undefined,
            tempC: ev.payload.tempC as number | undefined,
            occurredAt: new Date(ev.occurredAt).getTime(),
          },
        ],
      };
    }
    case "logistics.SingleWindowCleared": {
      const auth = String(ev.payload.authority ?? "").toLowerCase();
      return {
        ...state,
        customsCleared: { ...state.customsCleared, dubaiTrade: state.customsCleared.dubaiTrade || auth.includes("dubai") },
      };
    }
    case "logistics.MoccaeCleared": {
      return { ...state, customsCleared: { ...state.customsCleared, moccae: true } };
    }
    default:
      return state;
  }
}
